// Services data
export const SERVICES = [
  {
    id: 1,
    title: "Aluminium & Glass Works",
    slug: "aluminium-glass-works",
    description: "Comprehensive fabrication and installation of aluminium and glass structures for modern architecture.",
    details: [
      "Building Glass Cladding",
      "Aluminium Louver Works",
      "Curtain Wall Systems",
      "Structural Glazing"
    ],
    icon: "Layers",
    image: "/images/Frameless Glass Façade at City Walk,  Al Safa St - Al Wasl - Dubai.webp"
  },
  {
    id: 2,
    title: "Aluminium Windows",
    slug: "aluminium-windows",
    description: "Custom window fabrication with superior quality and design for residential and commercial spaces.",
    details: [
      "Casement Windows",
      "Awning Windows",
      "Fixed Windows",
      "Tilt & Turn Windows"
    ],
    icon: "LayoutGrid",
    image: "/images/Aluminum sliding window and single door with tinted glass at Dibba Al-Fujairah.webp"
  },
  {
    id: 3,
    title: "Aluminium Doors",
    slug: "aluminium-doors",
    description: "Sturdy, durable aluminium doors with powder-coated finishes resistant to fading.",
    details: [
      "Swing Doors",
      "French Doors",
      "Pivot Doors",
      "Automatic Doors"
    ],
    icon: "DoorOpen",
    image: "/images/Aluminum Framed Double-Leaf Glass Door System at City Walk,  Al Safa St - Al Wasl - Dubai.webp"
  },
  {
    id: 4,
    title: "Sliding Windows & Doors",
    slug: "sliding-windows-doors",
    description: "Space-saving sliding solutions that add a modern touch to apartments and villas.",
    details: [
      "Sliding Windows",
      "Sliding Patio Doors",
      "Lift & Slide Doors",
      "Multi-Track Systems"
    ],
    icon: "SlidersHorizontal",
    image: "/images/White aluminum sliding window with black tinted glass at Al Barsha Villa.webp"
  },
  {
    id: 5,
    title: "Louvered Door & Partitions",
    slug: "louvered-partitions",
    description: "Airflow-optimized louvered solutions for water tanks, electrical rooms, and ventilation areas.",
    details: [
      "Ventilation Louvers",
      "Louvered Doors",
      "Privacy Screens",
      "Sun Shading Systems"
    ],
    icon: "Fence",
    image: "/images/Premium Powder-Coated Aluminum Louver Door Installation at  Dubai Outsource City.webp"
  },
  {
    id: 6,
    title: "Maintenance Services",
    slug: "maintenance",
    description: "Expert maintenance and repair services for all aluminium and glass installations.",
    details: [
      "Preventive Maintenance",
      "Repair Services",
      "Glass Replacement",
      "Hardware Upgrades"
    ],
    icon: "Wrench",
    image: "/images/Silicone sealing application on façade glass for weatherproofing and durability at dubai outsource city.webp"
  }
];

// Projects data
export const PROJECTS = [
  {
    id: 1,
    title: "Aluminum double door",
    client: "Commercial Client",
    location: "jebel ali",
    category: "Commercial",
    year: "2023",
    description: "Premium aluminum double door installation with high-quality finishes.",
    image: "/images/Aluminum Double Door at jebel ali.webp"
  },
  {
    id: 2,
    title: "Aluminum framed double-leaf glass door system",
    client: "City Walk",
    location: "Al Safa St - Al Wasl - Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium aluminum framed double-leaf glass door system installation with high-quality finishes.",
    image: "/images/Aluminum Framed Double-Leaf Glass Door System at City Walk,  Al Safa St - Al Wasl - Dubai.webp"
  },
  {
    id: 3,
    title: "Aluminum sliding window and single door with tinted glass",
    client: "Commercial Client",
    location: "Dibba Al-Fujairah",
    category: "Commercial",
    year: "2023",
    description: "Premium aluminum sliding window and single door with tinted glass installation with high-quality finishes.",
    image: "/images/Aluminum sliding window and single door with tinted glass at Dibba Al-Fujairah.webp"
  },
  {
    id: 4,
    title: "Clean and durable aluminum door with glass panel",
    client: "Commercial Client",
    location: "Dibba Al-Fujairah",
    category: "Commercial",
    year: "2023",
    description: "Premium clean and durable aluminum door with glass panel installation with high-quality finishes.",
    image: "/images/Clean and durable aluminum door with glass panel at Dibba Al-Fujairah.webp"
  },
  {
    id: 5,
    title: "Curved frameless glass balcony with stainless steel fittings for a modern interior finish",
    client: "Commercial Client",
    location: "jumeirah 18 villa complex",
    category: "Commercial",
    year: "2023",
    description: "Premium curved frameless glass balcony with stainless steel fittings for a modern interior finish installation with high-quality finishes.",
    image: "/images/Curved frameless glass balcony with stainless steel fittings for a modern interior finish at jumeirah 18 villa complex.webp"
  },
  {
    id: 6,
    title: "Custom interior fit-out with glass & stone finishes",
    client: "Madinat Jumeirah",
    location: "Al Sufouh 1 - Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium custom interior fit-out with glass & stone finishes installation with high-quality finishes.",
    image: "/images/Custom Interior Fit-Out with Glass & Stone Finishes at Madinat Jumeirah, Al Sufouh 1 - Dubai.webp"
  },
  {
    id: 7,
    title: "Custom oval mirror installation with slim metal frame",
    client: "Madinat Jumeirah",
    location: "Al Sufouh 1 - Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium custom oval mirror installation with slim metal frame installation with high-quality finishes.",
    image: "/images/Custom Oval Mirror Installation with Slim Metal Frame at Madinat Jumeirah, Al Sufouh 1 - Dubai.webp"
  },
  {
    id: 8,
    title: "Custom wall-mounted mirror",
    client: "Al Wasl Sports Club",
    location: "Al Jadaf - Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium custom wall-mounted mirror installation with high-quality finishes.",
    image: "/images/Custom wall-mounted mirror at Al Wasl Sports Club, Al Jadaf - Dubai.webp"
  },
  {
    id: 9,
    title: "Electrical access panel cover",
    client: "al rawabi dairy farm",
    location: "Al Khawaneej - Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium electrical access panel cover installation with high-quality finishes.",
    image: "/images/Electrical Access Panel Cover at al rawabi dairy farm, Al Khawaneej - Dubai.webp"
  },
  {
    id: 10,
    title: "Elegant blue-tinted glass entrance with premium stainless steel finishing",
    client: "Commercial Client",
    location: "Dubai Internet City",
    category: "Commercial",
    year: "2023",
    description: "Premium elegant blue-tinted glass entrance with premium stainless steel finishing installation with high-quality finishes.",
    image: "/images/Elegant Blue-Tinted Glass Entrance with Premium Stainless Steel Finishing at Dubai Internet City.webp"
  },
  {
    id: 11,
    title: "Elegant frameless shower glass partition with premium black aluminum",
    client: "Commercial Client",
    location: "al warqa 3",
    category: "Commercial",
    year: "2023",
    description: "Premium elegant frameless shower glass partition with premium black aluminum installation with high-quality finishes.",
    image: "/images/Elegant Frameless Shower Glass Partition with Premium Black Aluminum at al warqa 3.webp"
  },
  {
    id: 12,
    title: "Fire rated door installation",
    client: "Commercial Client",
    location: "Al Aweer",
    category: "Commercial",
    year: "2023",
    description: "Premium fire rated door installation installation with high-quality finishes.",
    image: "/images/Fire Rated Door Installation at Al Aweer.webp"
  },
  {
    id: 13,
    title: "Frameless curved glass partition for modern office interiors",
    client: "Commercial Client",
    location: "Dubai World Trade Centre",
    category: "Commercial",
    year: "2023",
    description: "Premium frameless curved glass partition for modern office interiors installation with high-quality finishes.",
    image: "/images/Frameless curved glass partition for modern office interiors at Dubai World Trade Centre.webp"
  },
  {
    id: 14,
    title: "Frameless glass enclosure with clean lines and modern finish",
    client: "Commercial Client",
    location: "Dibba Al-Fujairah",
    category: "Commercial",
    year: "2023",
    description: "Premium frameless glass enclosure with clean lines and modern finish installation with high-quality finishes.",
    image: "/images/Frameless glass enclosure with clean lines and modern finish at Dibba Al-Fujairah.webp"
  },
  {
    id: 15,
    title: "Frameless glass façade",
    client: "City Walk",
    location: "Al Safa St - Al Wasl - Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium frameless glass façade installation with high-quality finishes.",
    image: "/images/Frameless Glass Façade at City Walk,  Al Safa St - Al Wasl - Dubai.webp"
  },
  {
    id: 16,
    title: "Frameless glass shower partition with chrome fittings",
    client: "Al Mankhool",
    location: "Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium frameless glass shower partition with chrome fittings installation with high-quality finishes.",
    image: "/images/Frameless glass shower partition with chrome fittings at Al Mankhool, Dubai.webp"
  },
  {
    id: 17,
    title: "Frameless sliding glass shower partition with matte black hardware",
    client: "Commercial Client",
    location: "Al Barsha",
    category: "Commercial",
    year: "2023",
    description: "Premium frameless sliding glass shower partition with matte black hardware installation with high-quality finishes.",
    image: "/images/Frameless sliding glass shower partition with matte black hardware at Al Barsha.webp"
  },
  {
    id: 18,
    title: "Frosted frameless glass partition with floor-mounted door",
    client: "Little Diamond Nursery The Gardens - Nursery in The Gardens",
    location: "Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium frosted frameless glass partition with floor-mounted door installation with high-quality finishes.",
    image: "/images/Frosted frameless glass partition with floor-mounted door at Little Diamond Nursery The Gardens - Nursery in The Gardens, Dubai.webp"
  },
  {
    id: 19,
    title: "Frosted glass restroom cubicles with aluminum framing",
    client: "Al Wasl Sports Club",
    location: "Al Jadaf - Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium frosted glass restroom cubicles with aluminum framing installation with high-quality finishes.",
    image: "/images/Frosted glass restroom cubicles with aluminum framing at Al Wasl Sports Club, Al Jadaf - Dubai.webp"
  },
  {
    id: 20,
    title: "Glass door with frosted finish",
    client: "Madinat Jumeirah",
    location: "Al Sufouh 1 - Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium glass door with frosted finish installation with high-quality finishes.",
    image: "/images/Glass Door with Frosted Finish at Madinat Jumeirah, Al Sufouh 1 - Dubai.webp"
  },
  {
    id: 21,
    title: "Glass double door",
    client: "Little Diamond Nursery The Gardens - Nursery in The Gardens",
    location: "Dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium glass double door installation with high-quality finishes.",
    image: "/images/Glass Double Door at Little Diamond Nursery The Gardens - Nursery in The Gardens, Dubai.webp"
  },
  {
    id: 22,
    title: "Modern frameless glass shower partition and mirror with premium black finish",
    client: "Commercial Client",
    location: "jumeirah 18 villa complex",
    category: "Commercial",
    year: "2023",
    description: "Premium modern frameless glass shower partition and mirror with premium black finish installation with high-quality finishes.",
    image: "/images/Modern frameless glass shower partition and Mirror with premium black finish at  jumeirah 18 villa complex.webp"
  },
  {
    id: 23,
    title: "Modern office cabin with clear glass partitioning",
    client: "Commercial Client",
    location: "Trade Center",
    category: "Commercial",
    year: "2023",
    description: "Premium modern office cabin with clear glass partitioning installation with high-quality finishes.",
    image: "/images/Modern Office Cabin with Clear Glass Partitioning at Trade Center.webp"
  },
  {
    id: 24,
    title: "Modern office entrance glass door",
    client: "Commercial Client",
    location: "jebel ali",
    category: "Commercial",
    year: "2023",
    description: "Premium modern office entrance glass door installation with high-quality finishes.",
    image: "/images/Modern Office Entrance Glass Door at  jebel ali .webp"
  },
  {
    id: 25,
    title: "Powder-coated aluminum door with integrated louver panel",
    client: "Commercial Client",
    location: "jebel ali",
    category: "Commercial",
    year: "2023",
    description: "Premium powder-coated aluminum door with integrated louver panel installation with high-quality finishes.",
    image: "/images/Powder-Coated Aluminum Door with Integrated Louver Panel at  jebel ali .webp"
  },
  {
    id: 26,
    title: "Powder-coated aluminum exterior door",
    client: "Commercial Client",
    location: "Dibba Al-Fujairah",
    category: "Commercial",
    year: "2023",
    description: "Premium powder-coated aluminum exterior door installation with high-quality finishes.",
    image: "/images/Powder-coated aluminum exterior door at Dibba Al-Fujairah.webp"
  },
  {
    id: 27,
    title: "Powder-coated aluminum framed glass entrance door",
    client: "Commercial Client",
    location: "Rahmaniya sharjah",
    category: "Commercial",
    year: "2023",
    description: "Premium powder-coated aluminum framed glass entrance door installation with high-quality finishes.",
    image: "/images/Powder-Coated Aluminum Framed Glass Entrance Door at Rahmaniya sharjah.webp"
  },
  {
    id: 28,
    title: "Premium blue-tinted glass door installation with stainless steel finish",
    client: "Commercial Client",
    location: "Dubai Internet City",
    category: "Commercial",
    year: "2023",
    description: "Premium premium blue-tinted glass door installation with stainless steel finish installation with high-quality finishes.",
    image: "/images/Premium Blue-Tinted Glass Door Installation with Stainless Steel Finish at Dubai Internet City.webp"
  },
  {
    id: 29,
    title: "Premium powder-coated aluminum louver door installation",
    client: "Commercial Client",
    location: "Dubai Outsource City",
    category: "Commercial",
    year: "2023",
    description: "Premium premium powder-coated aluminum louver door installation installation with high-quality finishes.",
    image: "/images/Premium Powder-Coated Aluminum Louver Door Installation at  Dubai Outsource City.webp"
  },
  {
    id: 30,
    title: "Shower partition",
    client: "Commercial Client",
    location: "muhaisnah 2 dubai",
    category: "Commercial",
    year: "2023",
    description: "Premium shower partition installation with high-quality finishes.",
    image: "/images/Shower Partition at muhaisnah 2 dubai.webp"
  },
  {
    id: 31,
    title: "Silicone sealing application on façade glass",
    client: "Commercial Client",
    location: "dubai outsource city",
    category: "Commercial",
    year: "2023",
    description: "Premium silicone sealing application on façade glass installation with high-quality finishes.",
    image: "/images/Silicone sealing application on façade glass at dubai outsource city.webp"
  },
  {
    id: 32,
    title: "Silicone sealing application on façade glass for weatherproofing and durability",
    client: "Commercial Client",
    location: "dubai outsource city",
    category: "Commercial",
    year: "2023",
    description: "Premium silicone sealing application on façade glass for weatherproofing and durability installation with high-quality finishes.",
    image: "/images/Silicone sealing application on façade glass for weatherproofing and durability at dubai outsource city.webp"
  },
  {
    id: 33,
    title: "White aluminum sliding window with black tinted glass",
    client: "Commercial Client",
    location: "Al Barsha Villa",
    category: "Commercial",
    year: "2023",
    description: "Premium white aluminum sliding window with black tinted glass installation with high-quality finishes.",
    image: "/images/White aluminum sliding window with black tinted glass at Al Barsha Villa.webp"
  }
];

// Clients data
export const CLIENTS = [
  { id: 1, name: "Emaar Properties", logo: "/images/emaar-logo.svg" },
  { id: 2, name: "DAMAC", logo: "/images/damac-logo.webp" },
  { id: 3, name: "Nakheel", logo: "/images/nakheel-logo.webp" },
  { id: 4, name: "Dubai Holding", logo: "/images/dubai-holding-logo.webp" },
  { id: 5, name: "Meraas", logo: "/images/meraas-logo.webp" },
  { id: 6, name: "Al Futtaim", logo: "/images/al-futtaim-logo.webp" },
  { id: 7, name: "Sobha Realty", logo: "/images/sobha-logo.webp" },
  { id: 8, name: "Azizi Developments", logo: "/images/azizi-logo.webp" },
  { id: 9, name: "Select Group", logo: "/images/select-group-logo.webp" },
  { id: 10, name: "MAG Group", logo: "/images/mag-group-logo.webp" },
  { id: 11, name: "Deyaar", logo: "/images/deyaar-logo.webp" },
  { id: 12, name: "Ellington Properties", logo: "/images/ellington-logo.webp" }
];

// Team/Organization data
export const TEAM = [
  {
    id: 1,
    name: "Mohammed Al Rashid",
    position: "Managing Director",
    department: "Executive",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?q=85&w=400&auto=format&fit=crop"
  },
  {
    id: 2,
    name: "Ahmed Hassan",
    position: "Operations Manager",
    department: "Operations",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=85&w=400&auto=format&fit=crop"
  },
  {
    id: 3,
    name: "Sara Khan",
    position: "Project Manager",
    department: "Projects",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=85&w=400&auto=format&fit=crop"
  },
  {
    id: 4,
    name: "Khalid Omar",
    position: "Technical Director",
    department: "Technical",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=85&w=400&auto=format&fit=crop"
  },
  {
    id: 5,
    name: "Fatima Al Zahra",
    position: "Finance Manager",
    department: "Finance",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=85&w=400&auto=format&fit=crop"
  },
  {
    id: 6,
    name: "Rashid Ali",
    position: "Sales Manager",
    department: "Sales",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=85&w=400&auto=format&fit=crop"
  }
];

// Stats data
export const STATS = [
  { label: "Years Experience", value: 10, suffix: "+" },
  { label: "Projects Completed", value: 500, suffix: "+" },
  { label: "Happy Clients", value: 200, suffix: "+" },
  { label: "Expert Team", value: 50, suffix: "+" }
];

// Why choose us data
export const WHY_CHOOSE = [
  { icon: "Award", title: "Premium Quality", desc: "Highest grade materials and craftsmanship" },
  { icon: "Users", title: "Expert Team", desc: "150+ skilled engineers and installers" },
  { icon: "Shield", title: "Safety Certified", desc: "ASTM, BS, EN compliant products" },
  { icon: "Zap", title: "Fast Delivery", desc: "On-time project completion guaranteed" },
  { icon: "Globe", title: "Global Partners", desc: "Saint-Gobain, Guardian, Schuco" },
  { icon: "Building2", title: "All Sectors", desc: "Commercial, Industrial, Residential" }
];

// Other Services data
export const OTHER_SERVICES = [
  {
    id: 1,
    slug: "glass-aluminum-installation",
    title: "Glass & Aluminum Installation & Maintenance",
    description: "Expert installation and comprehensive maintenance services for all types of glass and aluminum structures. We ensure durability, safety, and aesthetic perfection for both residential and commercial properties.",
    features: ["Custom Fabrication", "Routine Maintenance", "Emergency Repairs", "Quality Assurance"],
    image: "https://images.unsplash.com/photo-1541888086425-d81bb19240f5?q=80&w=2000&auto=format&fit=crop"
  },
  {
    id: 2,
    slug: "plumbing-sanitary",
    title: "Plumbing & Sanitary Installation",
    description: "Professional plumbing and sanitary installation services for new constructions and renovations. Our certified plumbers guarantee leak-proof, efficient, and code-compliant water systems.",
    features: ["Pipe Installation", "Fixture Fitting", "Drainage Systems", "Water Heater Setup"],
    image: "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?q=80&w=2000&auto=format&fit=crop"
  },
  {
    id: 3,
    slug: "carpentry-wood-flooring",
    title: "Carpentry & wood Flooring Works",
    description: "High-quality carpentry and wood flooring solutions. From custom cabinetry and doors to premium hardwood floor installations, our craftsmen deliver exceptional finishes.",
    features: ["Custom Woodwork", "Hardwood Flooring", "Door Installation", "Cabinet Making"],
    image: "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?q=80&w=2000&auto=format&fit=crop"
  },
  {
    id: 4,
    slug: "electrical-fittings-repair",
    title: "Electrical Fittings & Fixtures Repairing & Maintenance",
    description: "Comprehensive electrical services ensuring safety and efficiency. We handle installation, repair, and maintenance of all electrical fittings and light fixtures.",
    features: ["Wiring & Rewiring", "Lighting Installation", "Fault Finding", "Panel Upgrades"],
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?q=80&w=2000&auto=format&fit=crop"
  },
  {
    id: 6,
    slug: "painting-contracting",
    title: "Painting Contracting",
    description: "Transform your spaces with our premium painting services. We offer interior and exterior painting for commercial and residential properties using high-quality, durable paints.",
    features: ["Interior Painting", "Exterior Coatings", "Texture Painting", "Surface Preparation"],
    image: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?q=80&w=2000&auto=format&fit=crop"
  },
  {
    id: 7,
    slug: "wallpaper-fixing",
    title: "Wallpaper Fixing Works",
    description: "Precision wallpaper installation services. Our experts ensure seamless alignment, bubble-free application, and perfect finishing for all types of designer wallpapers.",
    features: ["Vinyl Wallpaper", "Fabric Wallpaper", "Mural Installation", "Wall Preparation"],
    image: "https://images.unsplash.com/photo-1615529182904-14819c35db37?q=80&w=2000&auto=format&fit=crop"
  },
  {
    id: 8,
    slug: "floor-wall-tiling",
    title: "Floor & Wall Tiling Works",
    description: "Expert tiling services for floors and walls. We work with ceramic, porcelain, marble, and granite to create stunning and durable surfaces for bathrooms, kitchens, and living areas.",
    features: ["Ceramic Tiling", "Marble Installation", "Grouting", "Waterproofing"],
    image: "https://images.unsplash.com/photo-1523413363574-c30aa1c2a516?q=80&w=2000&auto=format&fit=crop"
  },
  {
    id: 9,
    slug: "building-cleaning",
    title: "Building Cleaning Services",
    description: "Professional building cleaning and maintenance services. We offer deep cleaning, facade washing, and routine janitorial services to keep your property pristine.",
    features: ["Facade Cleaning", "Deep Cleaning", "Post-Construction Clean", "Routine Janitorial"],
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=80&w=2000&auto=format&fit=crop"
  },
  {
    id: 10,
    slug: "false-ceiling-light-partitions",
    title: "False Ceiling & Light Partitions Installation",
    description: "Modern false ceiling and partition installations to enhance aesthetics and acoustics. We provide gypsum, metal, and acoustic solutions tailored to your space.",
    features: ["Gypsum Ceilings", "Grid Ceilings", "Glass Partitions", "Drywall Installation"],
    image: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?q=80&w=2000&auto=format&fit=crop"
  }
];

// Contact info
export const CONTACT_INFO = {
  phones: ["0522104001", "045668983"],
  email: "info@greatiga.ae",
  address: "D65 Al Marabea' St - Al Qouz Ind.fourth - Al Quoz - Dubai",
  mapLink: "https://share.google/AjwEbHKjtqfOu6Y7l",
  instagram: "https://www.instagram.com/greatiga.ae?igsh=anIzeWowNjhldno4",
  workingHours: "Mon - Sat: 8:00 AM - 5:00 PM",
  whatsapp: "971522104001" // international format (wa.me needs country code, no leading 0)
};

// Company info
export const COMPANY_INFO = {
  name: "Great International Glass & Aluminium Works LLC",
  shortName: "Great International",
  tagline: "Premier Fabrication Services",
  description: "Specialized in Aluminium and Glass Fabrication & Installation Works for Commercial, Industrial & Residential Projects across the UAE.",
  founded: "2008",
  vision: "To become the leading provider of innovative glass and aluminium solutions in the UAE and beyond, setting industry standards for quality and excellence.",
  mission: "To deliver exceptional glass and aluminium fabrication services that exceed client expectations through innovation, precision, and commitment to quality."
};

// Navigation structure
export const NAV_ITEMS = [
  { label: "Home", path: "/" },
  {
    label: "About Us",
    path: "/about",
    children: [
      { label: "Company Profile", path: "/about/company-profile" },
      { label: "Organization Chart", path: "/about/organization" },
      { label: "Careers", path: "/about/careers" }
    ]
  },
  { label: "Services", path: "/services", isMega: true },
  { label: "Other Services", path: "/other-services", isMega: true },
  {
    label: "Projects",
    path: "/projects",
    children: [
      { label: "Our Clients", path: "/projects/clients" },
      { label: "Completed Projects", path: "/projects/completed" },
      { label: "Projects Gallery", path: "/projects/gallery" }
    ]
  },
  { label: "Contact Us", path: "/contact" }
];

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_0f41aede-4e46-4d59-8ed3-615d485e326d/artifacts/h2gytv6b_Untitled%20design%20%2854%29.png";
